import appConstants from '../constants';
import fetchService from './fetchService';
import convertPartnerQualIconsStringToArray from '../utils/convertQualIconsStringToArray';
import convertQualIconsArrayToRolesAndLevelsObject from '../utils/convertQualIconsArrayToRolesAndLevelsObject';
import extractDiversityInfoFromQualifications from '../utils/extractDiversityInfoFromQualifications';
const SERVICE_URL = `${appConstants.SERVICE_BASE_URL}${appConstants.SERVICE_REQUEST_SEARCH_PARTNERS_URL}`;

// {
// "SITE_ID" : "2132140",
// "pageSize": 1,
// "pageCount": 1
// }
// Later i will add PARTNER_KEYWORD_ID

function convertPaginationCriteria() {
  return Object.fromEntries(
    new Map([
      [appConstants.KEY_PAGE_SIZE, 1],
      [appConstants.KEY_PAGE_COUNT, 1]
    ])
  );
}

function convertPartnerSiteId(partnerSiteId) {
  return Object.fromEntries(
    new Map([
      [appConstants.KEY_SITE_ID, partnerSiteId],
    ])
  );
}

function prepareInputParameters(partnerSiteId) {
  return {
    ...convertPartnerSiteId(partnerSiteId),
    ...convertPaginationCriteria()
  };
}

function processData(data) {
  let processedData = {
    foundPartner: null
  }
  if(!!data.data && !!data.data.length) {
    processedData = {
      foundPartner: data.data.map(partner => {
        const rolesAndLevels =
          convertQualIconsArrayToRolesAndLevelsObject(
            convertPartnerQualIconsStringToArray(partner[appConstants.KEY_QUAL_ICONS])
          );
        const diversityInfo = extractDiversityInfoFromQualifications(partner?.qualifications||[]);
        return {
          ...partner,
          ...rolesAndLevels,
          ...diversityInfo,
          isSaved: false,
          savedCount: 0,
        }
      })[0]
    }
  }
  return processedData;
}

export default async function fetchPartnerDetails(
  searchCriteria,
  paginationCriteria = { pageSize: 50, pageCount: 1 },
  sortCriteria = {}
) {
  const inputParameters = prepareInputParameters(searchCriteria, paginationCriteria, sortCriteria);

  let fetchedDataObject = await fetchService(
    'fetchPartnerDetails',
    SERVICE_URL,
    {
      ...appConstants.SERVICE_REQUEST_SEARCH_PARTNERS_CONFIG,
      body: JSON.stringify(inputParameters)
    }
  );

  return !fetchedDataObject.success?
    {
      hasError: true,
      errorMessage: fetchedDataObject.statusMessage,
      foundPartner: null
    } :
    {
      hasError: false,
      errorMessage: null,
      ...processData(fetchedDataObject)
    };
}
